import { useState } from "react";
import 'react-dates/initialize';
import { isInclusivelyBeforeDay, SingleDatePicker } from "react-dates";
import datePickerIcon from "../assets/icons/date_picker_icon.svg";
import moment from "moment";

const CustomInputIcon = () => {
  return <img src={datePickerIcon} alt="date-picker-icon" />;
};

const DatePicker = ({
  date,
  onDateChange,
  dateDisplayFormat,
  placeholder,
  allowPreviousDates,
  disableFutureDates,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <SingleDatePicker
      numberOfMonths={1}
      onDateChange={(date) => onDateChange(date)}
      onFocusChange={({ focused }) => setFocused(focused)}
      focused={focused}
      date={date}
      displayFormat={dateDisplayFormat}
      showDefaultInputIcon={false}
      customInputIcon={<CustomInputIcon />}
      inputIconPosition="after"
      hideKeyboardShortcutsPanel
      placeholder={placeholder}
      isOutsideRange={
        disableFutureDates
          ? (day) => !isInclusivelyBeforeDay(day, moment())
          : allowPreviousDates
          ? () => false
          : (day) => {
              if (day.isSameOrBefore(moment().subtract(1, "day"))) {
                return true;
              }
              return false;
            }
      }
    />
  );
};

export default DatePicker;
